import { render, staticRenderFns } from "./BotoesCriar.vue?vue&type=template&id=394c99cf"
import script from "./BotoesCriar.vue?vue&type=script&lang=js"
export * from "./BotoesCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports